import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router} from '@angular/router';
import {NotifierService} from 'angular-notifier';
import {Formatters} from 'angular-slickgrid';
import {MessageService} from '../message.service';
import {RestApiService} from '../rest-api.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-flow-component-details',
  templateUrl: './flow-component-details.component.html',
  styleUrls: ['./flow-component-details.component.css']
})
export class FlowComponentDetailsComponent implements OnInit, OnDestroy {

  displayed = true;
  totalData = 0;
  show: boolean;
  selected: number;
  respObject: any;
  tables: any[];
  metaTableSelected: number;
  tableName: string;
  displayData: any;
  add: boolean;
  del: boolean;
  edit: boolean;
  view: boolean;
  isError = false;
  errorMessage: string;
  private notifier: NotifierService;

  tableFields = [];
  tableFieldName: string;
  metaTableFieldSelected: number;
  workflowSelected: any;
  workflows = [];
  fieldType = [];
  private workflowName: any;
  fieldTypeSelected: any;
  slideChecked = false;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  clientId: number;
  private baseFlag: any;
  private adminAuth: Subscription;
  offset: number;
  dataLoaded:boolean;

  constructor(private _rest: RestApiService, private messageService: MessageService,
              private route: Router, private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          // console.log('changed');
          if (!this.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {

          }
          break;
        case 'delete':
          // console.log('deleted');
          if (!this.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              this._rest.deleteWorkFlowComponentDetails({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                  // this.totalData = this.totalData - 1;
                  // this.messageService.setTotalData(this.totalData);
                  this.messageService.sendAfterDelete(item.id);
                } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.respObject.errorMessage);
              });
            }
          }
          break;
      }
    });
    this.messageService.getUserAuth().subscribe(details => {
      // console.log(JSON.stringify(details));
      if (details.length > 0) {
        this.add = details[0].addFlag;
        this.del = details[0].deleteFlag;
        this.view = details[0].viewFlag;
        this.edit = details[0].editFlag;
      } else {
        this.add = false;
        this.del = false;
        this.view = false;
        this.edit = false;
      }
    });
    this.messageService.getSelectedItemData().subscribe(selectedTitles => {
      if (selectedTitles.length > 0) {
        this.show = true;
        this.selected = selectedTitles.length;
      } else {
        this.show = false;
      }
    });
  }

  ngOnInit() {
    this.dataLoaded=false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    // this.messageService.setGridWidth(1000);

    this.displayData = {
      pageName: 'Maintain Workflow Component Details',
      openModalButton: 'Add Component Details',
      breadcrumb: 'ComponentDetails',
      folderName: 'All Component Details',
      tabName: 'Workflow Component Details'
    };

    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, maxWidth: 30, filterable: true},
      {
        id: 'workflow', name: 'Workflow', field: 'workflow', sortable: true, filterable: true
      },
      {
        id: 'table', name: 'Table', field: 'tableName', sortable: true, filterable: true
      },
      {
        id: 'tableField', name: 'Primary Key Field ', field: 'tableField', sortable: true, filterable: true
      },
      {
        id: 'type', name: 'Field Type ', field: 'fieldType', sortable: true, filterable: true
      },
      {
        id: 'resolution', name: 'Resolution Field ', field: 'resolution', sortable: true, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    this._rest.getMetadataTable().subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        // console.log(JSON.stringify(this.respObject));
        this.respObject.details.unshift({id: 0, name: 'Select Table'});
        this.tables = this.respObject.details;
        this.metaTableSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
    this._rest.getWorkFlow().subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.details[0].unshift({id: 0, name: 'Select Workflow'});
        this.workflows = this.respObject.details[0];
        this.workflowSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
    this.fieldType = [{name: 'int'}, {name: 'string'}, {name: 'boolean'}];
    if (this.messageService.clientId) {
        this.clientId = this.messageService.clientId;
        this.baseFlag = this.messageService.baseFlag;
        this.onPageLoad();
    } else {
        this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
                this.clientId = details[0].clientId;
                this.baseFlag = details[0].baseFlag;
                this.onPageLoad();
            }
        });
    }
  }

    onPageLoad() {
        this.getTableData();
    }

  openModal(content) {
    if (!this.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.metaTableSelected = 0;
      this.metaTableFieldSelected = 0;
      this.workflowSelected = 0;
      this.slideChecked = false;
      this.fieldTypeSelected = 'int';
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {

      });
    }
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  save() {
    const data = {
      work_flow_id: this.workflowSelected,
      tableName: this.tableName,
      createdBy: this.messageService.getUserId(),
      fieldnm: this.tableFieldName,
      fieldType: this.fieldTypeSelected,
      resolutionField: this.slideChecked
    };
    if (!this.messageService.isBlankField(data)) {
      this._rest.insertWorkFlowComponentDetails(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.isError = false;
          const id = this.respObject.id;
          this.messageService.setRow({
            id: id,
            workflow: this.workflowName,
            tableName: this.tableName,
            tableField: this.tableFieldName,
            fieldType: this.fieldTypeSelected,
            resolution: this.slideChecked
          });
            this.totalData = this.totalData + 1;
            this.messageService.setTotalData(this.totalData);

            if (this.totalData <= this.pageSize * this.page_no) {
                this.offset = id;
                this.nextOffset = 0;
            } else {
                this.nextOffset = this.offset;
            }
          this.metaTableSelected = 0;
          this.metaTableFieldSelected = 0;
          this.workflowSelected = 0;
          this.fieldTypeSelected = 'int';
          this.slideChecked = false;


        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = this.messageService.SERVER_ERROR;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    if (!this.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

  }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded=false;
        this._rest.getWorkFlowComponentDetails(offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.respObject.errorMessage);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.adminAuth) {
            this.adminAuth.unsubscribe();
        }
    }

  onTableChange(selectedIndex: any) {
    this.tableName = this.tables[selectedIndex].name;
    this._rest.getFieldByTable(this.metaTableSelected).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.details.unshift({id: 0, name: 'Select Table Fields'});
        this.tableFields = this.respObject.details;
        this.metaTableFieldSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  onTableFieldChange(selectedIndex: any) {
    this.tableFieldName = this.tableFields[selectedIndex].name;
  }


  onWorkflowChange(selectedIndex: any) {
    this.workflowName = this.workflows[selectedIndex].name;
  }

  slideChange() {
    this.slideChecked = !this.slideChecked;
  }
}
